import { init } from '@rematch/core';
import { RematchRootDispatch, RematchRootSelect, RematchRootState } from '../../rematch';
import selectPlugin from '@rematch/select';
import * as models from './models';

export type IDispatch = RematchRootDispatch<typeof models>;
export type IRootState = RematchRootState<typeof models>;
export type IRootSelect = RematchRootSelect<typeof models, IRootState>;

export const store = init<IRootState, IDispatch, IRootSelect>({
  models,
  plugins: [selectPlugin()],
});
